// = Libs =
import { FC } from 'react';
import clsx from 'clsx';

// = Styles =
import classes from '../card.module.scss';

// = Types =
import { CardHeaderProps } from './card-header.types';

// = Components =
import Label from '@/common/components/ui/label/label';

const CardHeader: FC<CardHeaderProps> = (props) => {
  const { children, label = '', labelColor = 'warning', className = '' } = props;

  return (
    <div
      className={clsx(
        {
          [classes['card__header']]: label,
          [classes['card__header--single']]: !label,
        },
        className
      )}>
      {label && <Label text={label} color={labelColor} />}

      {children}
    </div>
  );
};

export default CardHeader;
